export type Quiz409Translations = {
  title: string;
  subMessage: string;
  buttons: {
    back: string;
  };
};

export const quizExpiredTranslations: Quiz409Translations = {
  title: 'Ups! Skończył Ci się czas.',
  subMessage: 'W tym roku nie udało Ci się ukończyć wszystkich zadań kwalifikacyjnych.',
  buttons: {
    back: 'Wróć',
  },
};
